import React, { useState } from 'react';
import { getAudio, downloadAudio } from '../core/_requests';

const AudioPlayer = ({ uniqueId, status }: { uniqueId: string, status: string }) => {
  const [audioUrl, setAudioUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleLoadAudio = async () => {
    if (audioUrl) return; 
    
    setLoading(true);
    try {
      const response = await getAudio(uniqueId);
      const url = URL.createObjectURL(response.data);
      setAudioUrl(url);
    } catch (err: any) {
      if (err.response?.data instanceof Blob) {
        const reader = new FileReader();
        reader.onload = () => {
          try {
            const errorData = JSON.parse(reader.result as string);
            alert(errorData.message || "File tidak tersedia");
          } catch {
            alert(reader.result || "File tidak tersedia");
          }
        };
        reader.readAsText(err.response.data);
      } else {
        alert(err.response?.data?.message || "Terjadi kesalahan sistem");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async () => {
    try {
      setLoading(true);
      
      const response = await downloadAudio(uniqueId); 
      
      const disposition = response.headers['content-disposition'];
      let filename = `recording_${uniqueId}.wav`; 
      if (disposition) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(disposition);
        
        if (matches != null && matches[1]) { 
          filename = matches[1].replace(/['"]/g, '').replace('UTF-8\'\'', '');
          filename = decodeURIComponent(filename);
        }
      }

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename); 
      document.body.appendChild(link);
      link.click();
      if (link.parentNode) {
        link.parentNode.removeChild(link);
      }
      window.URL.revokeObjectURL(url);
      
    } catch (err: any) {
      console.error("Gagal mengunduh rekaman", err);
      if (err.response?.data instanceof Blob) {
        const errorText = await err.response.data.text();
        try {
          const errorJson = JSON.parse(errorText);
          alert(errorJson.message || "File tidak tersedia");
        } catch {
          alert(errorText || "File tidak tersedia");
        }
      } else {
        alert(err.response?.data?.message || "Koneksi ke server terputus");
      }
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <span>Loading...</span>;

  return (
    <div className="d-flex align-items-center gap-2">
      {status === 'ANSWERED' ?
      <>
      <button 
        className="btn btn-sm btn-icon btn-light-primary" 
        onClick={handleLoadAudio}
        title="Play Recording"
        disabled={loading}
      >
        <i className="bi bi-play-fill fs-3"></i>
      </button>

      <button 
        className="btn btn-sm btn-icon btn-light-success" 
        onClick={handleDownload}
        title="Download Recording"
        disabled={loading}
      >
        <i className="bi bi-download fs-3"></i>
      </button>

      {audioUrl && (
        <audio controls style={{ height: '30px', width: '200px' }}>
          <source src={audioUrl} type="audio/wav" />
        </audio>
      )}

      {loading && <span className="ms-2">Loading...</span>}
      </>:<></>
      }
    </div>
  );
};

export default AudioPlayer;